import { routes } from '@/shared/routes';

import { checkAmlIntercept } from '@/front/actions/xama';
import { setEditableValue } from '@/front/editable/state';
import { POST } from '@/front/fetch';
import { alertModal } from '@/front/modal';

export const toggleSetDate = async (button: HTMLAnchorElement | HTMLButtonElement) => {
  const { editableId, value, toggled } = button.dataset;

  if (editableId) {
    if (editableId === 'completedDate' && toggled !== 'true') {
      const taskId = button.dataset.taskId;

      if (taskId) {
        const intercepted = await checkAmlIntercept(taskId, {
          onComplete: () => window.location.reload(),
        });

        if (intercepted) return;
      }
    }

    const date = value ? new Date(Date.parse(value)) : new Date();

    await setEditableValue(editableId, toggled !== 'true' ? date : null);

    button.dataset.toggled = toggled !== 'true' ? 'true' : 'false';
  }
};

export const createSmartTasks = async (button: HTMLAnchorElement | HTMLButtonElement) => {
  const accountId = button.dataset.value;

  if (accountId) {
    const res = await POST(routes.admin.accounts.createSmartTasks({ id: accountId }));

    const message = await res.text();

    if (message) {
      alertModal(message);
    }
  }
};
